export const BACKEND_API_URL = process.env.NEXT_PUBLIC_STORAGE_URL || ''
export const ImageBaseUrl = process.env.NEXT_PUBLIC_STORAGE_URL || ''
export const ImagePath = '/assets/images'